import React from 'react';
import { ImageProps } from '.';

const SvgNpay = ({ size = 37, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 2.642857142857143)) || 14}
      fill='none'
      viewBox='0 0 37 14'
      {...props}
    >
      <path
        fill='#333'
        d='M18.697 3h2.968a3.88 3.88 0 0 1 1.219.171c.317.1.609.263.857.478.225.201.398.45.506.727.113.29.17.6.166.91v.233c.003.313-.058.624-.178.915a2.139 2.139 0 0 1-.522.749 2.513 2.513 0 0 1-.856.511c-.38.132-.783.196-1.187.189h-1.835V11h-1.14l.002-8Zm1.142.954V6.93h1.632c1.199 0 1.798-.477 1.797-1.429v-.2c0-.459-.144-.798-.432-1.016-.288-.218-.7-.327-1.24-.327l-1.758-.003ZM27.341 11.088c-.638 0-1.143-.15-1.515-.454a1.56 1.56 0 0 1-.43-.565 1.503 1.503 0 0 1-.13-.689v-.3a1.6 1.6 0 0 1 .13-.689c.093-.218.234-.414.412-.575.36-.326.945-.489 1.753-.489h1.6v-.354c0-.407-.1-.714-.305-.904-.205-.19-.536-.295-.996-.295-.329-.007-.656.05-.963.166-.295.124-.579.272-.847.444l-.553-.798a5.37 5.37 0 0 1 1.038-.539c.426-.158.88-.236 1.336-.227.328-.003.654.04.969.127.274.077.53.205.754.377a1.76 1.76 0 0 1 .675 1.426V11h-1.071v-.732h-.014a1.197 1.197 0 0 1-.248.305 1.776 1.776 0 0 1-.34.238c-.172.09-.356.16-.547.206-.232.051-.47.075-.708.072Zm1.82-2.857h-1.578c-.438 0-.751.082-.94.245a.83.83 0 0 0-.282.677v.156c-.01.125.014.25.071.363.057.113.144.21.252.28.232.137.5.207.773.2.243.004.486-.028.72-.095.202-.063.391-.16.559-.286a.98.98 0 0 0 .328-.382 1.37 1.37 0 0 0 .098-.56V8.23ZM34.164 9.78l1.66-4.857H37L33.727 13.5l-1.015-.344.819-2.076-2.294-6.158h1.212l1.67 4.857h.045Z'
      />
      <path fill='#00C73C' d='M14 0H0v14h14V0Z' />
      <path fill='#fff' d='M8.113 10.5 5.854 6.877V10.5H3.5v-7h2.387l2.259 3.623V3.5H10.5v7H8.113Z' />
    </svg>
  );
};

export default SvgNpay;
